import Button from '@bugbug/core/components/Button';
import dayjs from 'dayjs';
import { Trans, useTranslation } from 'react-i18next';

import useModal from '~/hooks/useModal';
import { selectSubscription } from '~/modules/organization/organization.selectors';
import { useAppSelector } from '~/modules/store';

import {
  SubscriptionModalContainer,
  SubscriptionModalContent,
  SubscriptionModalDetails,
  SubscriptionModalFooter,
  SubscriptionModalTitle,
} from '../Subscription/Subscription.styled';

import * as S from './DowngradeConfirmedModal.styled';

import CheckMarkIcon from '~/images/check-mark-icon.svg?react';

export const DowngradeConfirmedModal = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'downgradeConfirmedModal' });
  const modal = useModal();
  const activeSubscription = useAppSelector(selectSubscription);

  return (
    <SubscriptionModalContainer>
      <SubscriptionModalContent>
        <CheckMarkIcon width={48} height={48} />
        <SubscriptionModalDetails>
          <SubscriptionModalTitle>{t('title', 'Downgrade confirmed')}</SubscriptionModalTitle>
          {activeSubscription && (
            <S.DowngradeInfo>
              <Trans i18nKey="description">
                Your account will be downgraded at the end of the current billing period on{' '}
                <S.BillingCycleEnd>
                  {dayjs(activeSubscription.end).format('DD MMM YYYY')}
                </S.BillingCycleEnd>
                .
              </Trans>
            </S.DowngradeInfo>
          )}
        </SubscriptionModalDetails>
      </SubscriptionModalContent>
      <SubscriptionModalFooter>
        <Button variant="primary" onClick={modal.hide}>
          {t('done', 'Done')}
        </Button>
      </SubscriptionModalFooter>
    </SubscriptionModalContainer>
  );
};
